// Updated API service to match your backend structure
import { apiRequest } from "./axiosInstance";

// Get payroll data for all employees (your existing endpoint)
export const getPayRoles = async (params) => {
  try {
    console.log('Fetching payrolls with params:', params);
    
    const response = await apiRequest({
      url: "/payrole/getPayrole",
      method: "GET",
      params: params
    });
    
    console.log('Payroll API response:', response?.data);
    
    // Handle both success response format and direct data
    if (response?.data?.success) {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } else {
      // For backward compatibility with your current API
      return {
        success: true,
        data: response?.data || [],
        message: 'Payroll data fetched'
      };
    }
  } catch (error) {
    console.error('Get payrolls error:', error);
    return {
      success: false,
      error: error?.response?.data?.message || error?.message,
      message: error?.response?.data?.message || "Error while fetching payroll data!"
    };
  }
};

// Update payroll (your existing endpoint)
export const updatePayroleApi = async (id, body) => {
  try {
    console.log('Updating payroll for employee:', id, body);
    
    const response = await apiRequest({
      url: `/payrole/updatePayrole?id=${id}`,
      method: "PUT",
      data: body
    });
    
    console.log('Update payroll response:', response?.data);
    
    // Handle both success response format and direct data
    if (response?.data?.success !== undefined) {
      return response.data;
    } else {
      // For backward compatibility
      return {
        success: true,
        data: response?.data,
        message: 'Payroll updated successfully'
      };
    }
  } catch (error) {
    console.error('Update payroll error:', error);
    return {
      success: false,
      error: error?.response?.data?.message || error?.message,
      message: error?.response?.data?.message || "Error while updating payroll!"
    };
  }
};

// Distribute payroll to selected employees (NEW)
export const distributePayrollApi = async (data) => {
  try {
    console.log('Distributing payroll:', data);
    
    const response = await apiRequest({
      url: "/payrole/distribute",
      method: "POST",
      data: data
    });
    
    console.log('Distribute payroll response:', response?.data);
    
    return {
      success: response?.data?.success || true,
      data: response?.data?.data,
      message: response?.data?.message || 'Payroll distributed successfully'
    };
  } catch (error) {
    console.error('Distribute payroll error:', error);
    return {
      success: false,
      error: error?.response?.data?.message || error?.message,
      message: error?.response?.data?.message || "Error while distributing payroll!"
    };
  }
};

// Get payroll history for an employee (OPTIONAL - if you want to add this feature)
export const getEmployeePayrollHistory = async (employeeId, params) => {
  try {
    const response = await apiRequest({
      url: `/payrole/${employeeId}`,
      method: "GET",
      params: params
    });
    
    return {
      success: true,
      data: response?.data?.data || response?.data,
      message: response?.data?.message
    };
  } catch (error) {
    console.error('Get payroll history error:', error);
    return {
      success: false,
      error: error?.response?.data?.message || error?.message,
      message: error?.response?.data?.message || "Error while fetching payroll history!"
    };
  }
};

// Create payroll record (OPTIONAL - if needed)
export const createPayrollApi = async (data) => {
  try {
    const response = await apiRequest({
      url: "/payrole/",
      method: "POST",
      data: data
    });
    
    return {
      success: response?.data?.success || true,
      data: response?.data?.data || response?.data,
      message: response?.data?.message || 'Payroll created successfully'
    };
  } catch (error) {
    console.error('Create payroll error:', error);
    return {
      success: false,
      error: error?.response?.data?.message || error?.message,
      message: error?.response?.data?.message || "Error while creating payroll!"
    };
  }
};